import ApiService from "../ApiService";
import { StorageService } from "../StorageService";

const orderService = {
  getOrders(page, rowsPerPage, search, status, providerId, date, date2, searchType) {
    providerId = providerId || '';
    return ApiService.get(
      `/orders/search?page=${page}&perPage=${rowsPerPage}&searchString=${search}&orderStatus=${status}&providerId=${providerId}&dateAfter=${date}&dateBefore=${date2}&searchType=${searchType}`
    );
  },

  async getAppOrderPatient  (identification) {
    return ApiService.customRequest({
      url: '/orders/getAppOrderPatient',
      data: {
          identification: identification.toString()
      },
      method: 'POST'
  })
},

  getOrderWithId(id, showCanceled) {
    return ApiService.get(
      `/orders/searchOrder?id=${id}&showCanceled=${showCanceled}`
    );
  },

  getOrderWithMedicines(id) {
    return ApiService.get(
      `/orders/searchOrderWithMedicines?id=${id}`
    );
  },

  updateOrderStatus(data) {
    return ApiService.post("/orders/updateOrderStatus", data);
  },

  bulkUpdate(data) {
    return ApiService.post("/orders/bulkUpdate", data);
  },

  createOrder(formData) {
    let data = JSON.stringify(formData);
    return ApiService.post("/scheduling", formData);
  },

  uploadAttachment(orderId, files) {
    return ApiService.postFiles(`/scheduling/${orderId}/upload`, files);
  },

  getAttachment(id) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/orders/get-attachment/${id}`,
      method: 'post'
    })
  },

  cancelOrder(data) {
    return ApiService.post(`/orders/remove-order`, data);
  },

  getOrder(id) {
    return ApiService.get(`/orders/${id}`);
  },
  getTypePedidoOrder() {
    return ApiService.get(`/orders/typePedido`)
  },
  getTypeAuthorizationOrder() {
    return ApiService.get(`/orders/typeAuthorization`)
  },
  getDate(formInfo) {
    return ApiService.post(`/orders/getDatesEnable`, formInfo)
  },
  getAuthorizations(type, idNumber) {
    type = type || '';
    idNumber = idNumber || '';
    return ApiService.get(`/orders/authorizations?identificationType=${type}&identification=${idNumber}`);
  },

  getAuthorizationsWithProvider(type, idNumber, providerId) {
    type = type || '';
    idNumber = idNumber || '';
    return ApiService.get(`/orders/authorizations?identificationType=${type}&identification=${idNumber}&provider=${providerId}`);
  },

  bulkUpdateAdmin(data) {
    return ApiService.post("/orders/bulkUpdateByUser", data);
  },

  getLogBulkUpdateAdmin(){
    return ApiService.post("/orders/LogChangeStatusAdmin");
  }
};

export default orderService;
